module.exports = __webpack_public_path__ + "img/logo.28781be1.svg";